'use strict';

function initTooltip() {
    let currentTooltip = null;

    document.body.addEventListener('click', tooltipBodyClickHandler);

    function tooltipBodyClickHandler(e) {
        if (e.target.closest('[data-tooltip]')) {
            if (e.target.closest('.tooltip')) return;

            const $parent = e.target.closest('[data-tooltip]');

            if (currentTooltip) {
                const $_parent = currentTooltip.$parent;
                currentTooltip.$tooltip.classList.remove('tooltip_active');
                currentTooltip = null;

                if ($parent == $_parent) {
                    return
                }
            }

            let $tooltip = $parent.querySelector('.tooltip');

            if (!$tooltip) {
                $tooltip = document.createElement('div');
                $tooltip.classList.add('tooltip');
                $tooltip.innerHTML = `
                    <div class="tooltip__content">
                        ${$parent.dataset.tooltip}
                    </div>
                    <div class="tooltip__arrow"></div>
                `;
                $parent.append($tooltip);
            }

            let coords = $tooltip.getBoundingClientRect();
            let $tooltipArrow = $tooltip.querySelector('.tooltip__arrow');

            if (coords.top < 5) {
                $tooltip.classList.add('tooltip_bottom');
            } else {
                $tooltip.classList.remove('tooltip_bottom');
            }

            if (coords.right > window.innerWidth) {
                let offset = coords.right - window.innerWidth + 10;
                $tooltip.style.left = `calc(50% - ${offset}px)`;
                $tooltipArrow.style.left = `calc(50% + ${offset}px)`;
            } else if (coords.left < 0) {
                let offset = coords.right - window.innerWidth + 10;
                $tooltip.style.left = `calc(50% + ${offset}px)`;
                $tooltipArrow.style.left = `calc(50% - ${offset}px)`;
            }

            $tooltip.classList.add('tooltip_active');



            currentTooltip = { $parent, $tooltip };
        } else if (currentTooltip) {
            currentTooltip.$tooltip.classList.remove('tooltip_active');
            currentTooltip = null;
        }
    }
}

document.addEventListener('DOMContentLoaded', initTooltip);
